import React, { Component } from 'react'
import rohitgupta from '../images/rohitgupta.jpg'

export default class About extends Component {
  render () {
    return (
      <article
        id='about'
        className={`${this.props.article === 'about' ? 'active' : ''} ${
          this.props.articleTimeout ? 'timeout' : ''
        }`}
        style={{ display: 'none' }}
      >
        <h2 className='major'>About</h2>
        <p>I’m a professional skilled Front-end developer with 5+ years of experience. who is passionate about Reactjs, JavaScript, building great user experiences, fighting for simplicity over complexity, constantly Learning Reactjs, Node JS, and new Front end frameworks.</p>
        <p>
          I'm very familiar with ReactJS, HTML, CSS, JavaScript, PHP, jQuery,
          Gutenberg, Gatsby, and WordPress.
        </p>
        <p>I have good working experience in WordPress and React sites.</p>
        <ul className='icons'>
          <li>
            <a
              href='https://twitter.com/_rohitguptab'
              className='icon fa-twitter'
              target='_blank'
            >
              <span className='label'>Twitter</span>
            </a>
          </li>
          <li>
            <a
              href='https://www.facebook.com/rohitguptab3'
              className='icon fa-facebook'
              target='_blank'
            >
              <span className='label'>Facebook</span>
            </a>
          </li>
          <li>
            <a
              href='https://www.instagram.com/rohitguptab/'
              className='icon fa-instagram'
              target='_blank'
            >
              <span className='label'>Instagram</span>
            </a>
          </li>
          <li>
            <a href='https://github.com/rohitguptab' className='icon fa-github' target='_blank'>
              <span className='label'>GitHub</span>
            </a>
          </li>
          <li>
            <a
              href='https://www.linkedin.com/in/rohitguptab/'
              className='icon fa-linkedin'
              target='_blank'
            >
              <span className='label'>GitHub</span>
            </a>
          </li>
        </ul>
        {this.props.close}
      </article>
    )
  }
}
